export default {
    title: "EBCとオックスフォード大学の共催セミナー｜EBC Financial Group",
    description:
      "EBC Financial Groupとオックスフォード大学は、「経済学者の研究公開（WERD）」シリーズを共催し、一流の学者を集めて気候変動経済学に関する最先端の問題について議論します。金融リテラシー教育を通じて投資家を支援し、透明性と持続可能性に優れた経済の未来を築く私たちの取り組みをご覧ください。",
    word1: "EBC Financial Groupとオックスフォード大学経済学部",
    word2: "先端研究と現実世界を橋渡しし、世界経済を舵取る",
    word3: "要点",
    word4: "私たちとパートナーになりませんか？",
    word5: "概要",
    word6: "過去のセミナー",
    word7: "特別ゲスト",
    word8: "プレスリリース",
    word9: "教育で、未来に力を。",
    word10:
      "EBC Financial Groupは、アクセスしやすい金融教育の提供は金融機関の責務であると考えています。故に、オックスフォード大学経済学部と提携し、世界トップクラスの金融研究を人々に届けています。",
    word11:
      "「経済学者の研究公開（WERD）」シリーズを通して、金融リテラシーを高め、交流と協力を促し、次世代の投資家、リーダー、思想家を育成することに尽力しています。",
    word12:
      "今回のパートナーシップは、EBCの公平性、責任、誠実さという中核的な価値観に深く根ざしており、より透明性が高くて、包摂的な金融の未来を築くビジョンを裏付けます。",
    word13: "交流を通じて現実社会に影響力を",
    word14: "ウェビナー 第一回",
    word15: "租税回避に関する経済学",
    word16: "詳しく",
    word17:
      "脱税が世界経済と地域経済の両方に与える影響を調査し、複雑な経済問題に対処する上での金融リテラシーの重要性を強調しました。",
    word18: "関係者",
    word19:
      "アビ・アダムズ(Abi Adams)博士、オックスフォード大学経済学教授、モデレーター",
    word20:
      "サラ・クリフォード(Sarah Clifford)博士、オックスフォード大学経済学準教授",
    word21:
      "デイビッド・バレット(David Barrett)、\nEBC Financial Group英国法人のCEO、特別ゲスト",
    word22: "イベント期間",
    word23: "2024年3月1日",
    word24: "（「経済学者の研究発表（WERD）」2024～2025年シリーズ）",
    word25: "イベント形式",
    word26: "Zoom録画",
    word27: "WERD 第2回",
    word28: "サステナビリティの維持：経済成長と気候変動へのレジリエンスの両立",
    word29:
      "マクロ経済政策が経済の安定を確保しながら、世界で最も緊急性の高い環境問題のいくつかに対処するのにどのように役立つかを検討しました。",
    word30:
      "バヌ・デミール・パケル(Banu Demir Pakel)博士：セッションモデレーター、外部エンゲージメント担当副部長、経済学准教授",
    word31:
      "アンドレア・チアバリ(Andrea Chiavari)博士：基調講演講師兼パネリスト",
    word32:
      "ニコラ・レンジャー(Nicola Ranger)博士：オックスフォード大学環境変動研究グローバルファイナンスグループディレクター、オックスフォード大学上級研究員",
    word33: "David Barrett：EBC Financial Group 英国法人CEO",
    word34: "2024年11月（経済学者の研究内容（WERD）2024~2025）",
    word35:
      "オックスフォード大学経済学部初のHybrid event（オフラインとオンラインセミナー）とパネルディスカッションを行いました。",
    word36: "特別ゲスト",
    word37: "ニコラ・レンジャー(Nicola Ranger)",
    word38:
      "オックスフォード大学環境レジリエンスおよびマーティンシステム部門責任者",
    word39:
      "オックスフォード大学環境レジリエンスとマーティン・システムズ・レジリエンスの責任者。オックスフォード大学環境変動研究所にグローバル・ファイナンス＆エコノミクス・グループを設立し、金融機関、中央銀行、各国政府と緊密に連携しながら、金融、気候、自然、分析が交差する最先端の研究を推進しています。また、国際通貨基金（IMF）、世界銀行、NGFS、英国気候金融リスクフォーラムと協力し、ストレステストやシナリオ分析手法の開発に携わってきました。欧州連合、新興市場の持続可能投資における専門家、英国のグリーンテック顧問、FCDO、ロンドン・スクール・オブ・エコノミクスのアドバイザーも務めています。",
    word40: "アンドレア・チアバリ(Andrea Chiavari)",
    word41: "オックスフォード大学経済学部教授",
    word42:
      "専門はマクロ経済学、特に企業力学と技術革新。経済モデルがいかに持続可能な開発を支援できるかを探求しています。ほか、気候変動が企業の生産性や資本に与える影響についても研究しており、特に不確実な環境における経済効率とレジリエンスの強化、経済成長の推進におけるテクノロジーの役割に焦点を当てて研究を進めています。",
    word43: "バヌ・デミール・パケル(Banu Demir Pakel)",
    word44: "オックスフォード大学経済学部準教授",
    word45:
      "国際貿易と開発経済学の接点で、企業が貿易関連のショックにどのように適応し、その適応がマクロ経済成長や所得分配をどう影響するかに焦点を当てて研究しています。CEPR（国際貿易・地域経済プログラム）研究員、ミュンヘンのCESifoリサーチネットワーク研究員。",
    word46: "David Barrett",
    word47: "EBC Financial Group 英国法人CEO",
    word48:
      "Barrett氏は、大手金融機関からベンチャー企業に至るまで、外国為替、債券、デリバティブ等の金融商品分野において35年以上従事し、専門知識と経験豊富な金融プロフェッショナルです。世界的な金融危機と規制変革を乗り越え、経済サイクルと金融規制環境に対する深い理解と、リスク管理とビジネス戦略について知見を有しています。",
    word49: "Sarah Clifford",
    word50: "オックスフォード大学経済学部、経済学準教授",
    word51:
      " Sarah氏は公共経済学を専門とし、特に税金に関連する経済行動、国際企業税、多国籍企業の租税回避、家計による個人所得税回避に焦点を当てています。専門分野には公共経済学と応用ミクロ経済学が含まれます。 \n                        ",
    word52: "Abi Adams-Prassl",
    word53: "ナフィールド大学経済学教授、副学長（外部連携）",
    word54:
      "  Abi氏の応用経済学に関する研究では、消費者と家族の選択の計量分析に焦点を当てました。 研究の主なテーマは、データに対する意思決定に新しいモードを導入する実証的手法の開発、労働市場をより深く理解するために大規模なデータセットを活用すること、英国の法制度における司法へのアクセスを定量化するためのフレームワークの開発などです。  ",
    word55: "詳しくはこちら",
    word56: "プレスリリース",
    word57: "ともに未来を築く",
    word58:
      "EBCは、同じ志を目指す機関や変革者との新たなコラボレーションを積極的に模索しています。",
    word59: "お問い合わせ",
    placeholder1: "お名前",
    placeholder2: "メールアドレス",
    placeholder3: "電話番号",
    placeholder4: "認証コード",
}
